import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} - Velar Games`;
    } else {
      document.title = `Velar Games — Elder House`;
    }
  }, [title]);
};
